// import axios from 'axios'
import React, { useEffect, useState } from 'react'
// import CONSTANTS from '../CONSTANTS'
import API from '../methods/API'
// import QuotationCard from '../components/quotations/QuotationCard'
// import QuoteTable from '../coreComponents/QuoteTable'
import Table from '../components/core/table/Table'
import quotationMethods from '../methods/quotationMethods'
import CONSTANTS from '../CONSTANTS'

const QuotationList = () => {
    // let tableView = true
    const [quotations, setQuotations] = useState([])

    useEffect(() => {
        getQuotes()
    }, []);

    const getQuotes = () => {
        API.getAllQuotations().then((data) => {
            console.log(data)
            setQuotations(data)
        })
    }

    // let tableObj = {
    //     head: [
    //         { key: "Date", value: "Date" },
    //         { key: "Client Name", value: "Client Name" },
    //         { key: "Employee", value: "Employee" },
    //         { key: "City", value: "City" },
    //         // {key:"State", value:"State"},
    //         // {key:"Email", value:"Email"},
    //         { key: "Amount", value: "Amount" },
    //         // {key:"Concern Person", value:"Concern Person"},
    //         // {key:"Concern Phone", value:"Concern Phone"},
    //         // {key:"Concern Email", value:"Concern Email"},
    //         { key: "Status", value: "Status" },
    //     ],
    //     items: quotations
    // }
    // const deleteFn = (id) => {
    //     API.deleteQuotation(id).then((res) => {
    //         console.log(res);
    //         getQuotes()
    //     })
    // }
    console.log(quotations)

    return (
        <div>
            <h2> </h2>
            <div className='quotelist'>
                {/* {tableView && <QuoteTable tableObj={tableObj} deleteFn={deleteFn} />} */}
                {/* {!tableView && quotations.map((quotation, i) => <QuotationCard quotation={quotation} />)} */}
            </div>
           <div className='quotetion-list-view'>
                <Table
                    colms={CONSTANTS.QUOTATION_TABLE.HEADS}
                    items={quotationMethods.getModifiedQuotationList(quotations)}
                    heading={CONSTANTS.QUOTATION_TABLE.TITLE}
                />
            </div> 
        </div>
    )
}

export default QuotationList